module.exports = __webpack_public_path__ + "media/images/Cafod-Logo-409393d9b99c6f0fa81bb5408a763759.svg";